const intToTime12 = (t) => {
  const totalMinutes = parseInt(t, 10);
  if (isNaN(totalMinutes)) return "";

  const hours24 = Math.floor(totalMinutes / 60);
  let minutes = `${totalMinutes % 60}`;
  if (minutes.length === 1) minutes = `0${minutes}`;

  const meridiem = hours24 >= 12 ? "PM" : "AM";
  const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12;

  return `${hours12}:${minutes} ${meridiem}`;
};

export default intToTime12;
